import React from "react";
import { useSelector } from "react-redux";
import { CustomSalesCard } from "../../../../components/customSalesCard/index";
import Spinner from "../../../../components/presentationals/Spinner";
import Error from "../../../../components/Error/index";
import { roundToTwo } from "../../../../utils/common/index";

const CafPendencyView = ({
  isCsvActive,
  fetchCafPendencyCsvData,
  moduleName,
  section,
}) => {
  const { cafPendencyObj, actCsvLoading } = useSelector(
    (state) => state.activationSalesReducer
  );

  let {
    cafPendencyData: { ornCount, aoRejected, tvPending },
  } = cafPendencyObj;

  return (
    <>
      {cafPendencyObj.loading ? (
        <Spinner />
      ) : Object.keys(cafPendencyObj.cafPendencyData).length ? (
        <>
          <div className="d-block d-sm-none col-12">
            <div
              id="carousel-div"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="0"
                  className="active"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carousel-div"
                  data-bs-slide-to="2"
                ></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <CustomSalesCard
                    value={roundToTwo(ornCount)}
                    tileName="Total Order Input"
                    csvDownload={
                      isCsvActive === "Y" ? fetchCafPendencyCsvData : ""
                    }
                    col="4"
                    image="Image4"
                    gradient="4"
                    loading={actCsvLoading}
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
                <div className="carousel-item">
                  <CustomSalesCard
                    value={roundToTwo(aoRejected)}
                    tileName=" AO Rejected"
                    csvDownload={
                      isCsvActive === "Y" ? fetchCafPendencyCsvData : ""
                    }
                    csvName="rejected"
                    col="4"
                    image="Image4"
                    gradient="5"
                    loading={actCsvLoading}
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
                <div className="carousel-item">
                  <CustomSalesCard
                    value={roundToTwo(tvPending)}
                    tileName="TV Pending "
                    csvDownload={
                      isCsvActive === "Y" ? fetchCafPendencyCsvData : ""
                    }
                    csvName="pending"
                    col="4"
                    image="Image4"
                    gradient="6"
                    loading={actCsvLoading}
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-none d-sm-block col-12">
            <div className="row">
              <CustomSalesCard
                value={roundToTwo(ornCount)}
                tileName="Total Order Input"
                csvDownload={isCsvActive === "Y" ? fetchCafPendencyCsvData : ""}
                col="4"
                image="Image4"
                gradient="4"
                loading={actCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
              <CustomSalesCard
                value={roundToTwo(aoRejected)}
                tileName=" AO Rejected"
                csvDownload={isCsvActive === "Y" ? fetchCafPendencyCsvData : ""}
                csvName="rejected"
                col="4"
                image="Image4"
                gradient="5"
                loading={actCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
              <CustomSalesCard
                value={roundToTwo(tvPending)}
                tileName="TV Pending "
                csvDownload={isCsvActive === "Y" ? fetchCafPendencyCsvData : ""}
                csvName="pending"
                col="4"
                image="Image4"
                gradient="6"
                loading={actCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
            </div>
          </div>
        </>
      ) : (
        <Error error={cafPendencyObj.error} />
      )}
    </>
  );
};

export default CafPendencyView;
